var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.097,
    height: 19.024,
    viewBox: "0 0 18.097 19.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_956",
    "data-name": "Caminho 956",
    d: "M4660.024,7487h7.388l8.833,9.512-8.833,8.512h-7.388l8.191-8.512Z",
    transform: "translate(-4658.849 -7486.5)",
    fill: "rgba(212,175,55,0.9)",
    stroke: "rgba(212,175,55,0.9)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextContent);
export default __webpack_public_path__ + "static/media/nextContent.53c8c29b7498576158334923af9c1155.svg";
export { ForwardRef as ReactComponent };